import { ApplePayMark, GooglePayMark } from "./PayMarks";

// «Оплата телефоном» на витрине.
//
// Показываем действие, а не скриншот: от телефона расходятся волны, как от
// настоящего касания терминала. Волны двигают transform и opacity, никакой
// геометрии, поэтому анимация ничего не стоит.
const PhonePayPromo = ({ title, hint }) => (
  <div className="lp-glass overflow-hidden px-3 pb-5 pt-4">
    <div className="text-center">
      <p className="text-sm font-bold tracking-tight text-foreground">{title}</p>
      {hint ? <p className="mx-auto mt-1 max-w-[16rem] text-xs leading-relaxed text-muted-foreground">{hint}</p> : null}
    </div>

    <div className="relative flex justify-center overflow-hidden pb-2 pt-5">
      <div className="lp-waves" aria-hidden="true">
        <i /><i /><i />
      </div>

      <div className="relative z-[1] w-[112px] rounded-[17px] bg-[linear-gradient(160deg,#333846,#0e1118_45%,#2a2e3a)] p-1.5 shadow-[0_16px_30px_-16px_rgba(0,0,0,0.9)]">
        <div className="relative overflow-hidden rounded-[12px] bg-[#0B1120] px-1.5 pb-2 pt-4">
          <span className="absolute left-1/2 top-1 h-2 w-8 -translate-x-1/2 rounded-full bg-black" />
          <div className="relative aspect-[1.586/1] overflow-hidden rounded-lg bg-[linear-gradient(135deg,#0a1120,#14274a_46%,#070c18)]">
            <span className="absolute inset-0 bg-[radial-gradient(circle_at_22%_18%,rgba(59,130,246,0.75),transparent_62%),radial-gradient(circle_at_82%_78%,rgba(139,92,246,0.5),transparent_62%)]" />
            <span className="absolute inset-0 rounded-lg shadow-[inset_0_0_0_1px_rgba(255,255,255,0.18)]" />
          </div>
          <div className="mt-1.5 flex justify-center gap-1">
            <span className="flex items-center rounded-[5px] bg-white px-1.5 py-[3px] text-black">
              <ApplePayMark className="h-[9px] w-auto" />
            </span>
            <span className="flex items-center rounded-[5px] bg-white px-1.5 py-[3px] text-[#5F6368]">
              <GooglePayMark className="h-[9px] w-auto" />
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
);

export default PhonePayPromo;
